export const citySunHours = [
  {
    "city": "Toronto",
    "north": 314,
    "south": 785,
    "west": 635,
    "east": 641,
    "elec_cost_per_kwh": 0.18
  },
  {
    "city": "Vanvouver",
    "north": 288,
    "south": 825,
    "west": 611,
    "east": 633,
    "elec_cost_per_kwh": 0.1422
  },
  {
    "city": "Quebec City",
    "north": 306,
    "south": 844,
    "west": 665,
    "east": 651,
    "elec_cost_per_kwh": 0.0938
  },
  {
    "city": "Montreal",
    "north": 306,
    "south": 850,
    "west": 657,
    "east": 660,
    "elec_cost_per_kwh": 0.713
  },
  {
    "city": "Halifax",
    "north": 314,
    "south": 843,
    "west": 665,
    "east": 659,
    "elec_cost_per_kwh": 0.1635
  },
  {
    "city": "Kingston",
    "north": 313,
    "south": 819,
    "west": 654,
    "east": 659,
    "elec_cost_per_kwh": 0.102
  },
  {
    "city": "Ottawa",
    "north": 309,
    "south": 880,
    "west": 660,
    "east": 689,
    "elec_cost_per_kwh": 0.102
  },
  {
    "city": "Fredricton",
    "north": 306,
    "south": 863,
    "west": 647,
    "east": 676,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Moncton",
    "north": 304,
    "south": 822,
    "west": 653,
    "east": 634,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Winnipeg",
    "north": 304,
    "south": 1123,
    "west": 746,
    "east": 764,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Victoria",
    "north": 293,
    "south": 797,
    "west": 624,
    "east": 619,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Charlottetown",
    "north": 303,
    "south": 771,
    "west": 637,
    "east": 613,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Regina",
    "north": 309,
    "south": 1194,
    "west": 827,
    "east": 867,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Saskatoon",
    "north": 304,
    "south": 1180,
    "west": 803,
    "east": 846,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Edmonton",
    "north": 292,
    "south": 1108,
    "west": 732,
    "east": 744,
    "elec_cost_per_kwh": 0.09826
  },
  {
    "city": "Calgary",
    "north": 310,
    "south": 1153,
    "west": 770,
    "east": 799,
    "elec_cost_per_kwh": 0.93
  },
  {
    "city": "St. John.s",
    "north": 285,
    "south": 703,
    "west": 544,
    "east": 543,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Yellowknife",
    "north": 273,
    "south": 1051,
    "west": 676,
    "east": 701,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Kuglukuk",
    "north": 294,
    "south": 839,
    "west": 618,
    "east": 623,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Lethbridege",
    "north": 314,
    "south": 1145,
    "west": 772,
    "east": 801,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Keswick",
    "north": 313,
    "south": 796,
    "west": 649,
    "east": 654,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Niagara Falls",
    "north": 324,
    "south": 822,
    "west": 663,
    "east": 670,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Timmins",
    "north": 302,
    "south": 936,
    "west": 691,
    "east": 698,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Orillia",
    "north": 316,
    "south": 815,
    "west": 661,
    "east": 667,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Washington, D.C. (US)",
    "north": 336,
    "south": 861,
    "west": 694,
    "east": 697,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Los Angles (US)",
    "north": 365,
    "south": 960,
    "west": 860,
    "east": 829,
    "elec_cost_per_kwh": 0.25
  },
  {
    "city": "New York (US)",
    "north": 329,
    "south": 886,
    "west": 707,
    "east": 685,
    "elec_cost_per_kwh": 0.22
  },
  {
    "city": "Boston(US)",
    "north": 325,
    "south": 921,
    "west": 698,
    "east": 705,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Houston (US)",
    "north": 365,
    "south": 786,
    "west": 733,
    "east": 717,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Honolulu (US)",
    "north": 412,
    "south": 780,
    "west": 828,
    "east": 831,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Miami (US)",
    "north": 378,
    "south": 794,
    "west": 768,
    "east": 762,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Chicago (US)",
    "north": 322,
    "south": 881,
    "west": 710,
    "east": 691,
    "elec_cost_per_kwh": 0.1727
  },
  {
    "city": "Phoenix (US)",
    "north": 351,
    "south": 1097,
    "west": 925,
    "east": 955,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Philadelphia (US)",
    "north": 334,
    "south": 914,
    "west": 717,
    "east": 712,
    "elec_cost_per_kwh": 0.147
  },
  {
    "city": "San Antonio (US)",
    "north": 373,
    "south": 851,
    "west": 786,
    "east": 809,
    "elec_cost_per_kwh": null
  },
  {
    "city": "San Diego (US)",
    "north": 370,
    "south": 1007,
    "west": 851,
    "east": 895,
    "elec_cost_per_kwh": 0.39
  },
  {
    "city": "San Francisco (US)",
    "north": 354,
    "south": 983,
    "west": 820,
    "east": 835,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Dallas (US)",
    "north": 364,
    "south": 926,
    "west": 805,
    "east": 826,
    "elec_cost_per_kwh": null
  },
  {
    "city": "San Jose (US)",
    "north": 348,
    "south": 964,
    "west": 820,
    "east": 827,
    "elec_cost_per_kwh": 0.32
  },
  {
    "city": "Denver (US)",
    "north": 358,
    "south": 1088,
    "west": 826,
    "east": 869,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Kansas City(US)",
    "north": 337,
    "south": 968,
    "west": 759,
    "east": 785,
    "elec_cost_per_kwh": null
  },
  {
    "city": "New Orleans(US)",
    "north": 361,
    "south": 801,
    "west": 722,
    "east": 730,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Atlanta (US)",
    "north": 362,
    "south": 898,
    "west": 774,
    "east": 789,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Charlotte(US)",
    "north": 353,
    "south": 921,
    "west": 761,
    "east": 763,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Jacksonville(US)",
    "north": 365,
    "south": 817,
    "west": 737,
    "east": 750,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Seattle (US)",
    "north": 294,
    "south": 740,
    "west": 607,
    "east": 617,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Cairo (Egypt)",
    "north": 389,
    "south": 883,
    "west": 799,
    "east": 819,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Dubai (UAE)",
    "north": 403,
    "south": 897,
    "west": 808,
    "east": 812,
    "elec_cost_per_kwh": null
  },
  {
    "city": "London (UK)",
    "north": 258,
    "south": 652,
    "west": 505,
    "east": 502,
    "elec_cost_per_kwh": 0.3469
  },
  {
    "city": "Paris(France)",
    "north": 284,
    "south": 728,
    "west": 574,
    "east": 567,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Helsinki (Finland)",
    "north": 256,
    "south": 736,
    "west": 555,
    "east": 559,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Doha (Qatar)",
    "north": 410,
    "south": 863,
    "west": 786,
    "east": 790,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Riyadh (Saudi Arabia)",
    "north": 392,
    "south": 1043,
    "west": 922,
    "east": 920,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Jeddah (Saudi Arabia)",
    "north": 417,
    "south": 906,
    "west": 870,
    "east": 875,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Neom (Saudi Arabia)",
    "north": 369,
    "south": 1064,
    "west": 946,
    "east": 956,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Amsterdam (Netherlands)",
    "north": 275,
    "south": 689,
    "west": 551,
    "east": 527,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Gothenburg(Sweden)",
    "north": 256,
    "south": 712,
    "west": 536,
    "east": 563,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Vienna (Austria)",
    "north": 292,
    "south": 768,
    "west": 612,
    "east": 608,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Praque (Czech Republic)",
    "north": 272,
    "south": 700,
    "west": 551,
    "east": 549,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Budapest(Hungary)",
    "north": 300,
    "south": 783,
    "west": 618,
    "east": 612,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Zagreb (Croatia)",
    "north": 295,
    "south": 713,
    "west": 593,
    "east": 590,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Rome (Italy)",
    "north": 334,
    "south": 886,
    "west": 733,
    "east": 733,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Bern (Switzerand)",
    "north": 298,
    "south": 794,
    "west": 632,
    "east": 626,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Warsaw (Poland)",
    "north": 274,
    "south": 714,
    "west": 554,
    "east": 557,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Berlin(Germany)",
    "north": 273,
    "south": 723,
    "west": 565,
    "east": 544,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Bucharest(Romania)",
    "north": 323,
    "south": 885,
    "west": 697,
    "east": 710,
    "elec_cost_per_kwh": null
  },
  {
    "city": "Kyiv(Ukraine)",
    "north": 291,
    "south": 779,
    "west": 627,
    "east": 607,
    "elec_cost_per_kwh": null
  }
]